function CollapsibleNavigation(){
    return (
        <div className="collapse" id="collapseExample">
            <div className="card card-body mb-3">
                <ul className="nav nav-pills flex-column quint">
                <li className="mx-auto">
                    <a href="/" className="nav-link">
                    Főoldal
                    </a>
                </li>
                <hr />
                <li className="mx-auto">
                    <a href="/bemutatkozas" className="nav-link">
                    Bemutatkozás
                    </a>
                </li>
                <hr />
                <li className="mx-auto">
                    <a href="/shiatsu-technika" className="nav-link">
                    Shiatsu technika
                    </a>
                </li>
                <hr />
                <li className="mx-auto">
                    <a href="/kronobiologia" className="nav-link">
                    Kronobiológia
                    </a>
                </li>
                <hr />
                <li className="mx-auto">
                    <a href="/bowen-kezeles" className="nav-link">
                    Bowen-kezelés
                    </a>
                </li>
                <hr />
                <li className="mx-auto">
                    <a href="/indiai-fejmasszazs" className="nav-link">
                    Indiai fejmasszázs
                    </a>
                </li>
                <hr />
                <li className="mx-auto">
                    <a href="/metamorf-erintes" className="nav-link">
                    Metamorf érintés
                    </a>
                </li>
                <hr />
                <li className="mx-auto">
                    <a href="/arlista" className="nav-link">
                    Árlista
                    </a>
                </li>
                <hr />
                <li className="mx-auto">
                    <a href="/elerhetosegek" className="nav-link">
                    Elérhetőségek
                    </a>
                </li>
                </ul>
            </div>
        </div>
    );
}

export default CollapsibleNavigation;